export const LOGIN = '/';
export const SEARCH = '/search';
export const QUERY_DASHBOARD = '/query-dashboard';
export const DASHBOARD = '/dashboard';
export const SSO = '/sso';
